var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { ListItem as MuiListItem } from '@material-ui/core';
import { clickableStyle, makeStyles } from "../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    root: __assign({}, clickableStyle(theme)),
}); }, { name: 'SnListItem' });
var useOverwriteStyles = makeStyles({
    root: {
        '&$selected, &$selected:hover': {},
    },
    button: {
        '&:hover': {},
    },
    selected: {},
}, { name: 'SnMuiListItem' });
export var ListItem = function (props) {
    var className = props.className, others = __rest(props, ["className"]);
    var classes = useStyles(props);
    var overwriteClasses = useOverwriteStyles(props);
    return (React.createElement(MuiListItem, __assign({ classes: overwriteClasses, className: classNames(classes.root, className), button: true }, others)));
};
